export default "__VITE_ASSET__DZsfEjNN__"